<template>
  <div>
    <vue-content-loading
      v-for="i in 5"
      :key="i"
      :height="83"
      class="m__b--12"
    >
      <rect
        x="0"
        rx="4"
        width="100%"
        height="83" />
    </vue-content-loading>

  </div>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  components: {
    VueContentLoading,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user-employee/log-activity/jSkeletonLogActivityLogin.vue